module.exports = __webpack_public_path__ + "img/Weapon_21.01eed72b.png";